import { VueConstructor } from 'vue';
import moment from 'vue-moment';
import AdminLayout from '@shared/layouts/wrappers/admin-layout/admin-layout.vue';
import BpcPagesLayout from '@shared/layouts/wrappers/pages-layout/pages-layout.vue';
import Default from '@themes/architectui/src/Layout/Wrappers/baseLayout.vue';
import BpcMockupsLayout from '@/mockups/layouts/wrappers/BpcLayout.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import PublicLayout from '@shared/layouts/wrappers/public-layout/public-layout.vue';
import PaymentLayout from '@shared/layouts/wrappers/payment-layout/payment-layout.vue';
import PublicCalendarLayout from '@shared/layouts/wrappers/public-calendar-layout/public-calendar-layout.vue';
import AuthLayout from '@shared/layouts/wrappers/auth-layout.vue';
import PosLayout from '@shared/layouts/wrappers/pos-layout.vue';

import Sortable from 'sortablejs';

import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faStar,
  faPlus,
  faMinus,
  faTrash,
  faPlay,
  faBackward,
  faForward,
  faCaretLeft,
  faAngleDoubleRight,
  faAngleDoubleLeft,
  faDotCircle,
  faRocket,
  faQuestion,
  faEdit,
  faAngleUp,
  faAngleLeft,
  faAngleRight,
  faAngleDown,
  faUpload,
  faUndo,
  faQuestionCircle,
  faFileAlt,
  faFileCsv,
  faFileExcel,
  faFilePdf,
  faEnvelope,
  faSync,
  faBars,
  faEnvelopeOpenText,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faCalendarAlt,
  faBan,
  faArrowLeft,
  faArrowsAltH,
  faCheckCircle,
  faPercentage,
  faEuroSign,
  faMoneyBillWave,
  faPercent,
  faHandPointer,
  faTimes,
  faSave,
  faExpand,
  faCalendar,
  faTag,
  faTh,
  faList,
  faFileInvoice,
  faCreditCard,
  faPrint,
  faDownload,
  faFilter,
  faSearch,
  faClone,
  faWallet,
  faLink,
  faShoppingCart,
  faTicketAlt,
  faArchive,
  faGift,
  faCubes,
  faEllipsisH,
  faComment,
  faInfoCircle,
  faGlobe,
  faHouseUser,
  faColumns,
  faWindowMaximize,
  faCloudUploadAlt,
  faCloudDownloadAlt,
  faBell,
  faPaperPlane,
  faEnvelopeSquare,
  faExternalLinkAlt,
  faCalculator,
  faTrashAlt,
  faCheck,
  faFileArchive,
  faUser,
  faHome,
  faTachometerAlt,
  faRedo,
  faSortAmountDown,
  faSortAmountDownAlt,
  faLongArrowAltRight,
  faArrowRight,
  faArrowDown,
  faChartBar,
  faChartLine,
  faLanguage,
  faMinusCircle,
  faSignOutAlt,
  faQrcode,
  faBarcode,
  faIdCard,
  faIdBadge,
  faBullseye,
  faPlayCircle,
  faLockOpen,
  faAddressCard,
  faCopy,
  faLock,
  faDice,
  faStickyNote,
  faClock,
  faMapMarkerAlt,
  faExclamationCircle,
} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faStar,
  faPlus,
  faMinus,
  faTrash,
  faPlay,
  faBackward,
  faForward,
  faCaretLeft,
  faAngleDoubleRight,
  faAngleDoubleLeft,
  faDotCircle,
  faRocket,
  faQuestion,
  faEdit,
  faAngleUp,
  faAngleLeft,
  faAngleRight,
  faAngleDown,
  faUpload,
  faUndo,
  faQuestionCircle,
  faQuestionCircle,
  faFileAlt,
  faFileCsv,
  faFileExcel,
  faFilePdf,
  faEnvelope,
  faSync,
  faBars,
  faEnvelopeOpenText,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faCalendarAlt,
  faBan,
  faArrowLeft,
  faArrowsAltH,
  faCheckCircle,
  faPercentage,
  faEuroSign,
  faMoneyBillWave,
  faPercent,
  faHandPointer,
  faTimes,
  faSave,
  faExpand,
  faCalendar,
  faTag,
  faTh,
  faList,
  faFileInvoice,
  faCreditCard,
  faPrint,
  faDownload,
  faFilter,
  faSearch,
  faClone,
  faWallet,
  faLink,
  faShoppingCart,
  faTicketAlt,
  faArchive,
  faGift,
  faCubes,
  faEllipsisH,
  faComment,
  faInfoCircle,
  faGlobe,
  faHouseUser,
  faColumns,
  faWindowMaximize,
  faCloudUploadAlt,
  faCloudDownloadAlt,
  faBell,
  faPaperPlane,
  faEnvelopeSquare,
  faExternalLinkAlt,
  faCalculator,
  faTrashAlt,
  faCheck,
  faFileArchive,
  faUser,
  faHome,
  faTachometerAlt,
  faRedo,
  faSortAmountDown,
  faSortAmountDownAlt,
  faLongArrowAltRight,
  faArrowRight,
  faArrowDown,
  faChartBar,
  faChartLine,
  faLanguage,
  faMinusCircle,
  faSignOutAlt,
  faQrcode,
  faBarcode,
  faIdCard,
  faIdBadge,
  faBullseye,
  faPlayCircle,
  faLockOpen,
  faAddressCard,
  faCopy,
  faDice,
  faLock,
  faStickyNote,
  faClock,
  faMapMarkerAlt,
  faExclamationCircle,
);

declare module 'vue/types/vue' {}

const createSortable = (el, options, vnode) => {
  return Sortable.create(el, {
    ...options,
  });
};

export default class SharedModule {
  static install(Vue: VueConstructor<Vue>): void {
    console.log('initiating Shared module');

    Vue.use(moment);

    Vue.component('bpc-admin-layout', AdminLayout);
    Vue.component('bpc-public-layout', PublicLayout);
    Vue.component('bpc-payment-layout', PaymentLayout);
    Vue.component('bpc-public-calendar-layout', PublicCalendarLayout);
    Vue.component('bpc-theme-layout', Default);
    Vue.component('bpc-mockups-layout', BpcMockupsLayout);
    Vue.component('bpc-userpages-layout', BpcPagesLayout);
    Vue.component('bpc-auth-layout', AuthLayout);
    Vue.component('bpc-pos-layout', PosLayout);
    Vue.component('font-awesome-icon', FontAwesomeIcon);
    Vue.component('VuePerfectScrollbar', VuePerfectScrollbar);

    Vue.directive('sortable', (el: any, binding, vnode) => {
      const table = el;
      if (binding.value === true || binding.value.sort === true) {
        table._sortable = createSortable(table.querySelector('tbody'), binding.value, vnode);
      }
    });
  }
}
